import { Controller } from "@hotwired/stimulus"
import { gsap } from "gsap";

import { CustomEase } from "gsap/CustomEase";
import { RoughEase, ExpoScaleEase, SlowMo } from "gsap/EasePack";

import { Flip } from "gsap/Flip";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Observer } from "gsap/Observer";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { Draggable } from "gsap/Draggable";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { EaselPlugin } from "gsap/EaselPlugin";
import { PixiPlugin } from "gsap/PixiPlugin";
import { TextPlugin } from "gsap/TextPlugin";


gsap.registerPlugin(Flip,ScrollTrigger,Observer,ScrollToPlugin,Draggable,MotionPathPlugin,EaselPlugin,PixiPlugin,TextPlugin,RoughEase,ExpoScaleEase,SlowMo,CustomEase);

// Connects to data-controller="animations"
export default class extends Controller {
  static targets = ["heroButton", "textReveal", "heroImage", "heroContainer", "heroLine1", "heroParagraph"];
  connect() {
    gsap.set(this.heroParagraphTarget, { opacity: 0 })
    // this.animateHeroContainer()
    // this.animateHeroTextReveal()
    // // this.heroAnimation();
    // // this.animateTextReveal();
    // this.animateHeroImage();
    // this.animateHeroButtons()
    this.animateHeroSequence()
  }

  // animateHeroContainer() {
  //   gsap.fromTo(this.heroContainerTarget, {
  //     clipPath: "inset(0% 10% 100% 10%)",
  //   }, {
  //     clipPath: "inset(0% 0% 0% 0%)",
  //     duration: 1.5,
  //     ease: "power3.out",
  //   })
  // }
  animateHeroContainer() {
    gsap.from(this.heroContainerTarget, {
      opacity: 0,
      scale: 1.20, // Slightly bigger initially, then scales down to 1
      y: -35,      // Initially slightly higher
      duration: 1.1,
      ease: "power3.out",
    })
  }

  animateHeroTextReveal(t1) {
    gsap.from(this.heroLine1Target.querySelector('.line-inner'), {
      opacity: 0,
      y: "100%",          // starts fully below mask container
      rotation: 20,      // slight tilt initially
      duration: 1.4,
      ease: "power3.out",
    })



    // Second line: from right, delayed slightly
    // gsap.from(this.heroLine2Target.querySelector('span'), {
    //   xPercent: 100,
    //   opacity: 0,
    //   duration: 1.4,
    //   ease: "power3.out",
    //   delay: 0.3
    // })
  }

  animateHeroButtons() {
    gsap.from(this.heroButtonTargets, {
      opacity: 0,
      y: 40,               // starts below final position
      duration: 1.2,
      ease: "power2.out",
    })
  }

  heroAnimation() {
    console.log("Animation triggered")
    this.heroTargets.forEach(target => {
      gsap.from(target, {
        opacity: 0,
        y: 10,
        duration: 1.2,
        ease: "power2.out",
      });
    });
  }

  animateHeroImage() {
    gsap.from(this.heroImageTarget, {
      yPercent: 100,      // starts fully below its container
      opacity: 0,
      duration: 1.8,      // slower and smoother
      ease: "power3.out",
      delay: 0.3,         // slight delay to feel natural
    });
  }

  featureAnimation({ target, params: { direction } }) {
    const fromX = direction === "left" ? -100 : 100;
    gsap.from(target, {
      scrollTrigger: {
        trigger: target,
        start: "top 80%",
        toggleActions: "play none none reverse",
      },
      opacity: 0,
      x: fromX,
      duration: 1,
      ease: "power3.out",
    });
  }

  testimonialsAnimation({ target }) {
    gsap.from(target.querySelectorAll(".testimonial-card"), {
      scrollTrigger: {
        trigger: target,
        start: "top 85%",
      },
      opacity: 0,
      y: 50,
      duration: 0.8,
      ease: "power2.out",
      stagger: 0.2,
    });
  }

  textRevealAnimation({ target }) {
    const originalText = target.textContent;
    target.textContent = "";
    gsap.to(target, {
      scrollTrigger: {
        trigger: target,
        start: "top 80%",
      },
      duration: 1.5,
      text: {
        value: originalText,
        delimiter: " ",
      },
      ease: "none",
    });
  }

  imageScaleAnimation({ target }) {
    gsap.fromTo(target, { scale: 1.1 }, {
      scale: 1,
      scrollTrigger: {
        trigger: target,
        start: "top 90%",
        end: "top 50%",
        scrub: true,
      },
      ease: "power2.out",
    });
  }

  animateHeroSequence() {
    const tl = gsap.timeline()

    // 1. Hero container background animation first
    tl.from(this.heroContainerTarget, {
      opacity: 0,
      scale: 1.20, // your refined value
      y: -35,      // your refined value
      duration: 1,
      ease: "power3.out",
    })

    // 2. Main Hero Text (Line 1) animation next, slight overlap
    tl.from(this.heroLine1Target.querySelector('.line-inner'), {
      opacity: 0,
      y: "100%",        // your refined masked slide-up
      rotation: 20,     // your refined rotation
      duration: 1.4,
      ease: "power3.out",
    }, "-=0.6") // Starts 0.6s before container animation finishes for smooth overlap
    // Small paragraph (appears instantly after main headline animation)
    tl.to(this.heroParagraphTarget, {
      opacity: 1,
      duration: 0.3,
      ease: "power1.out",
    }, "-=0.8")

    // 3. Buttons appear next, also slightly overlapping text animation
    tl.from(this.heroButtonTargets, {
      opacity: 0,
      y: 40,            // your refined value
      duration: 1.2,    // your refined value
      ease: "power2.out",
    }, "-=0.8") // slight overlap with text animation

    // 4. Hero image slides up last, delayed slightly for natural effect
    tl.from(this.heroImageTarget, {
      yPercent: 100,    // your refined value
      opacity: 0,
      duration: 1.8,    // your refined slower and smoother duration
      ease: "power3.out",
    }, "-=1.0") // overlaps slightly with buttons for seamless flow
  }

}
